<template>
  <div class="monitoring-cabin-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="clickAdd" size="mini"
                     type="primary" icon="el-icon-plus">新增区域
          </el-button>
          <el-button @click="clickEdit" size="mini"
                     type="primary" icon="el-icon-edit">编辑区域
          </el-button>
          <el-button @click="showMapForDrawArea" size="mini"
                     type="primary" icon="el-icon-menu">设置区域
          </el-button>
          <el-button @click="setBaseStation" size="mini"
                     type="primary" icon="el-icon-s-tools">设置基站
          </el-button>
          <el-button @click="setUnlock" size="mini"
                     type="primary" icon="el-icon-unlock">允许人员进入设置
          </el-button>
          <el-button @click="setUnlock" size="mini"
                     type="primary" icon="el-icon-lock">禁止人员进入设置
          </el-button>
          <el-button @click="del" size="mini" type="primary"
                     icon="el-icon-delete">删除区域
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table"
                :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="区域名称" prop="name"></el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type=='special'">特殊区域</span>
            <span v-if="scope.row.type=='common'">普通区域</span>
          </template>
        </el-table-column>
        <el-table-column label="所在甲板" prop="deck"></el-table-column>
        <el-table-column label="限定总人数">100</el-table-column>
        <el-table-column label="基站设置">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain>已设置</el-button>
            <!--<el-button size="mini">未设置</el-button>-->
          </template>
        </el-table-column>
        <el-table-column label="允许谁进入">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" plain>已设置</el-button>
          </template>
        </el-table-column>
        <el-table-column label="不允许谁进入">
          <template slot-scope="scope">
            <el-button size="mini">未设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                     :current-page.sync="pagination.page"
                     :total="pagination.total" @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog class="dialog-map" title="设置区域" width="80%" :visible.sync="setAreaDialogIsShow">
      <div style="width:100%;height:400px;">
        <v-ship-map-set-area ref="shipmap" @transmit="transmit"
                             containerHeight="400"
                             :shipMapData="dataToMap"
                             :ship_img="ship_img">
        </v-ship-map-set-area>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="emptyData">清空</el-button>
        <el-button size="mini" type="primary" @click="submitSetDeckArea">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="currentRow?'编辑':'新建'" width="400px" :visible.sync="addDialogShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">所在甲板</span>
          <el-select style="width:100%" size="mini" v-model="addobj.select" placeholder="请选择甲板">
            <el-option
                v-for="item in [{value:'选项1',label:'选项1'},{value:'选项2',label:'选项2'},{value:'选项3',label:'选项3'},{value:'选项4',label:'选项4'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">类型</span>
          <el-select style="width:100%" size="mini" v-model="addobj.type" placeholder="请选择类型">
            <el-option
                v-for="item in [{value:'特殊区域',label:'特殊区域'},{value:'普通区域',label:'普通区域'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="o-hidden">
          <span class="span">区域编码</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">区域名称</span>
          <el-input size="mini" v-model="addobj.name"></el-input>
        </div>
        <div class="o-hidden">
          <span class="span">限定总人数</span>
          <el-input size="mini" type="number" v-model="addobj.count"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>

    <!--允许人员进入设置-->
    <el-dialog title="设置" width="800px" :visible.sync="unlockIsShow">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按用户设置" name="first">
          <div class="mb-20">
            <span>已选择人员：</span>
            <span class="mr-10"
                  v-for="(item,index) in allBaseStations"
                  :key="index" v-if="hasBaseStationIds.indexOf(item.id)>-1">
              <el-button size="mini">{{item.name}}</el-button></span>
          </div>
          <div class="auth-box">
            <div class="item" :class="item.active?'active':''" @click="setActive(index)"
                 v-for="(item,index) in allBaseStations" :key="index">
          <span class="zsf-icon check"
                :class="hasBaseStationIds.indexOf(item.id)>-1?'zsf-icon-yixuanze- color-409eff':'zsf-icon-weixuanze-1 color-dcdcdc'"></span>
              <span class="width-100 t-hidden">{{item.id}}</span>
              <span class="width-150 color-999 ml-10">{{item.name}}</span>
              <span class="color-999 ml-10">其他字段</span>
            </div>
          </div>
          <div class="pagination pt-10 t-center mt-10">
            <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                           :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                           :current-page.sync="pagination.page"
                           :total="pagination.total"
                           @size-change="changeSize"
                           @current-change="changeCurrent"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按管理人员设置" name="second">
          <el-tabs v-model="activeName22" @tab-click="handleClick22">
            <el-tab-pane label="全选管理员" name="second">
              <el-button size="mini" type="primary" @click="submitAuth">全选管理员</el-button>
            </el-tab-pane>
            <el-tab-pane label="勾选部分人员" name="first">
              <div class="mb-20">
                <span>已选择管理人员：</span>
                <span class="mr-10"
                      v-for="(item,index) in allBaseStations"
                      :key="index" v-if="hasBaseStationIds.indexOf(item.id)>-1">
              <el-button size="mini">{{item.name}}</el-button></span>
              </div>
              <div class="auth-box">
                <div class="item" :class="item.active?'active':''" @click="setActive(index)"
                     v-for="(item,index) in allBaseStations" :key="index">
          <span class="zsf-icon check"
                :class="hasBaseStationIds.indexOf(item.id)>-1?'zsf-icon-yixuanze- color-409eff':'zsf-icon-weixuanze-1 color-dcdcdc'"></span>
                  <span class="width-100 t-hidden">{{item.id}}</span>
                  <span class="width-150 color-999 ml-10">{{item.name}}</span>
                  <span class="color-999 ml-10">其他字段</span>
                </div>
              </div>
              <div class="pagination pt-10 t-center mt-10">
                <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                               :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                               :current-page.sync="pagination.page"
                               :total="pagination.total"
                               @size-change="changeSize"
                               @current-change="changeCurrent"></el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>

        </el-tab-pane>
        <el-tab-pane label="按角色设置" name="third">
          <el-select style="width:100%;" v-model="value1" multiple placeholder="请选择">
            <el-option v-for="item in ['超级管理员','管理员','普通用户']"
                       :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-tab-pane>
        <el-tab-pane label="按部门设置" name="fourth">
          <el-select style="width:100%;" v-model="value1" multiple placeholder="请选择">
            <el-option v-for="item in ['部门1','部门2','部门3']"
                       :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="unlockIsShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitAuth">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  import {mock} from '../../common/js/mock.js';
  import ShipMapSetArea from '../../components/ship-map-set-area.vue';
  export default {
    data() {
      return {
        ship_img: {
          url: '',
          width: 0,
          height: 0
        },
        setAreaDialogIsShow: false,
        dataToMap: {},
        dataFromMap: {},
        obj: {
          txt: "",
          txt11: "",
          select: "",
          select11: "",
          date: "",
          datas: "",
          dateTime: "",
          number: ""
        },
        list: [],
        currentRow: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        tableLoading: false,
        addobj: {name: "", type: '特殊区域', count: 10},
        addDialogShow: false,
        unlockIsShow: false,
        hasBaseStationIds: [1, 2, 8],
        allBaseStations: [],
        activeName: 'first',
        value1: '',
        activeName22: 'first'
      };
    },

    computed: {},

    created() {
      this.getData();
      this.ship_img.width = 5000;
      this.ship_img.height = 1815;
      this.ship_img.url = '1111';
    },

    methods: {
      submitSetDeckArea(){
        console.log(this.dataFromMap);
        alert('保存数据');
        this.setAreaDialogIsShow = false;
      },

      transmit(data){
        console.log(JSON.stringify(data));
        this.dataFromMap = data;
      },

      showMapForDrawArea(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        console.log(this.currentRow);
        this.setAreaDialogIsShow = true;
        this.dataToMap = {type: 'setArea', data: {id: this.currentRow.id, points: this.currentRow.points}};
        setTimeout(() => {
          this.$refs.shipmap.load();
        }, 10);
      },

      emptyData(){
        this.$refs.shipmap.drawAreaEsc();
      },

      setBaseStation(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        alert('设置基站，和前面“船舱总段”一样');
      },

      handleClick(tab, event){
        console.log(tab, event);
      },

      handleClick22(tab, event){
        console.log(tab, event);
      },

      setActive(index) {
        console.log(this.allBaseStations[index].id);
        let id = this.allBaseStations[index].id;
        let hasBaseStationIds = [...this.hasBaseStationIds];
        let isHas = hasBaseStationIds.indexOf(id);
        if (isHas > -1) {
          hasBaseStationIds.splice(index, 1);
        } else {
          hasBaseStationIds.push(id);
        }
        this.hasBaseStationIds = hasBaseStationIds;
        console.log(this.hasBaseStationIds);
      },

      submitAuth(){
        this.unlockIsShow = false;
      },

      setUnlock(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.unlockIsShow = true;
      },

      setLock(){
      },

      download() {
        let loadingInstance = Loading.service({
          fullscreen: true,
          text: "数据生成中"
        });
        setTimeout(() => {
          loadingInstance.close();
        }, 1000);
      },

      clickAdd() {
        this.addDialogShow = true;
        this.currentRow = null;
      },

      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.addDialogShow = true;
      },

      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      },

      submit() {
        console.log(this.addobj);
        this.addDialogShow = false;
      },

      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        this.tableLoading = false;
        //this.pagination.total = 222;
        this.pagination.total = mock.area.length;
        this.list = mock.area;
        let list = [];
        for (let i = 1; i < 11; i++) {
          list.push({id: i, name: '姓名' + i});
        }
        this.allBaseStations = list;
      },

      reset() {
        this.obj.page = 1;
        this.pagination.page = 1;
        this.getData();
      },

      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },

      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      }
    },

    components: {
      'v-ship-map-set-area': ShipMapSetArea
    }
  };
</script>

<style lang="less" rel="stylesheet/less">
  @import "../../common/less/ship-map.less";

  .monitoring-cabin-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: stretch;
    padding: 15px;
    flex-direction: column;
    .div {
      flex: 1;
      width: 0;
      display: flex;
      .input {
        flex: 1;
      }
      .btn {
        width: 80px;
      }
    }
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
